import { render, staticRenderFns } from "./IpBlacklistManagement.vue?vue&type=template&id=60e983ff&scoped=true"
import script from "./IpBlacklistManagement.vue?vue&type=script&lang=js"
export * from "./IpBlacklistManagement.vue?vue&type=script&lang=js"
import style0 from "./IpBlacklistManagement.vue?vue&type=style&index=0&id=60e983ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e983ff",
  null
  
)

export default component.exports